import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { DepotMarker } from "./depots-marker";
import { useDepots } from "@/api/depots";
import { useShortcutsStore } from "@/screens/dashboard/shortcuts.store";

interface DepotsLayerProps {
  zoomLevel: number;
}

export function DepotsLayer({ zoomLevel }: DepotsLayerProps) {
  const { showDepots } = useShortcutsStore();
  const { data: depots } = useDepots();

  if (!showDepots || !depots) return null;

  return (
    <>
      {depots.map((depot) => (
        <AdvancedMarker
          key={depot.id}
          position={{
            lat: depot.address.location.lat,
            lng: depot.address.location.lng,
          }}
        >
          <DepotMarker depot={depot} zoomLevel={zoomLevel} />
        </AdvancedMarker>
      ))}
    </>
  );
}
